import type { BasketShippingOptionModel } from 'autogen/swagger/all';
import useMediatorState, { mediatorAtom } from 'hooks/globals/useMediatorAtom';

export const ShippingOptionsQuickViewAtom = mediatorAtom<{
    isOpen: boolean;
    basketShippingOptionModel?: BasketShippingOptionModel;
}>({ isOpen: false });

export default function useShippingOptionsQuickView() {
    return useMediatorState(ShippingOptionsQuickViewAtom);
}
